/**
 * Aligns the Col elements vertically with form labels.
 * It is especially useful for elementa such as plain text and radio buttons.
 */
import { Col, ColProps } from "reactstrap";

const LabelCol = (props: ColProps) => {
  const { children, className, ...colProps } = props;

  const colClass = `${className ?? ''} col-form-label`.trim();

  return (
    <Col {...colProps} className={colClass}>
      {children}
    </Col>
  )
};

export default LabelCol;
